import React from "react";

/** Read-only JSON for run data (inputs, outputs, payloads). */
const JsonView = ({ value, maxHeight = 320 }: { value: any; maxHeight?: number }) => (
    <pre className="bg-light border rounded p-2 small mb-0" style={{ maxHeight, overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        {value === undefined || value === null ? '—' : JSON.stringify(value, null, 2)}
    </pre>
);

export default JsonView;
